import { FunctionComponent, JSX } from 'react'
import styles from './overlapsRegularSlotsDialog.module.scss'
import Checkbox from '@/components/_custom/Checkbox/Checkbox.tsx'
import { renderEventForRegularConflict } from '../../../utils/calendarEvents.tsx'
import { EventRegularOverlap } from '@/types/Slots.ts'

interface OverlapsElementProps {
    event: EventRegularOverlap
    checked: boolean
    handleCheck: (slotId: number, checked: boolean) => void
}

const OverlapsElement: FunctionComponent<OverlapsElementProps> = ({
    event,
    checked,
    handleCheck
}: OverlapsElementProps): JSX.Element => {
    return (
        <div className={styles.EventContainer}>
            <Checkbox
                className={styles.Checkbox}
                checked={checked}
                onChange={(): void => handleCheck(event.slotId, !checked)}
            />
            {renderEventForRegularConflict(event)}
        </div>
    )
}

export default OverlapsElement
